import { PersonalizationProvider } from '@lib/hooks/usePersonalizations'
import type { PaymentIntentStage } from '@lib/store/p2p/PaymentIntentStage'
import { INTENT_STAGE_REGEX } from '@lib/store/p2p/PaymentIntentStage'
import { useStores } from '@lib/store/useStores'
import type { ProfilePaymentPageProps } from '@server/helpers/profile'
import { useRouter } from 'next/router'
import { createContext, useContext, useMemo, useState } from 'react'
import type { FunctionComponent, PropsWithChildren } from 'react'

import { ProfilePaymentStore } from './ProfilePaymentStore'

/**
 * Gives you access to current page's TransferRequestPageStore.
 * Only works when there's valid transfer request and the page is wrapped in TransferRequestProvider
 */
export const useProfilePaymentStore = () => useContext(ProfilePayContext)

export const useIntentStage = () => {
    const { pathname } = useRouter()

    return useMemo(
        () =>
            (pathname.match(INTENT_STAGE_REGEX) ?? [])[0] as
                | PaymentIntentStage
                | undefined,
        [pathname],
    )
}

const ProfilePayContext = createContext<ProfilePaymentStore | undefined>(
    undefined,
)

export const ProfilePaymentProvider: FunctionComponent<
    PropsWithChildren<ProfilePaymentPageProps>
> = ({ children, ...props }) => {
    const { sdk } = useStores()
    const [store] = useState(() => new ProfilePaymentStore(sdk, props.profile))

    return (
        <PersonalizationProvider value={store.personalizations}>
            <ProfilePayContext.Provider value={store}>
                {children}
            </ProfilePayContext.Provider>
        </PersonalizationProvider>
    )
}
